import { SessionExpiredError } from '../../common/erros/SessionExpiredError';
import { AppError } from '../../common/erros/AppError';
import { ResponseCodes } from './ResponseCodes';
import { Pending2Fa } from '../../common/erros/Pending2Fa';

export function handleRemoteResponse<T>(response: any, mapper: (data: any) => T): T {

    const body = response.data;
    const code = body.code;
    if (code === ResponseCodes.OK) {
        return mapper(body.data);
    } else if ((code === ResponseCodes.NO_ACTIVE_SESSION) ||
        (code === ResponseCodes.INVALID_TOKEN)
        || (code === ResponseCodes.EXPIRED_TOKEN)) {
        throw new SessionExpiredError();
    } else if ((code === ResponseCodes.PENDING_VERIFY_2FA)) {
        throw new Pending2Fa(body.userMessage, code);
    } else {
        throw new AppError(body.userMessage ?? "Lo sentimos, intente más tarde");
    }
}
